import {roleSystemRoute} from './route_utilities'

import Brands from '../../views/brands/Brands.vue'
import CreateBrand from '../../views/brands/CreateBrand.vue'
import Brand from '../../views/brands/Brand.vue'
import BrandGeneral from '../../views/brands/BrandGeneral.vue'
import BrandTranslations from '../../views/brands/BrandTranslations.vue'
import BrandSuppliers from '../../views/brands/BrandSuppliers.vue'
import BrandProjects from '../../views/brands/BrandProjects.vue'
import CreateBrandProject from '../../views/brands/CreateBrandProject.vue'
import CreateSupplier from '../../views/brands/CreateSupplier.vue'
import BrandUsers from '../../views/brands/BrandUsers.vue'
import CreateBrandUser from '../../views/brands/CreateBrandUser.vue'
import BrandUser from '../../views/brands/BrandUser.vue'
import BrandStatus from '../../views/brands/BrandStatus.vue'
import BrandCustomAttributes from '../../views/brands/BrandCustomAttributes.vue'
import CreateBrandCustomAttribute from '../../views/brands/CreateBrandCustomAttribute.vue'
import CreateBrandCustomAttributeGroup from '../../views/brands/CreateBrandCustomAttributeGroup.vue'
import BrandCustomAttribute from '../../views/brands/BrandCustomAttribute.vue'
import BrandCustomAttributeGroup from '../../views/brands/BrandCustomAttributeGroup.vue'
import BrandReports from '../../views/brands/BrandReports.vue'
import BrandReport from '../../views/brands/BrandReport.vue'
import BrandReportEdit from '../../views/brands/BrandReportEdit.vue'
import BrandExpenses from '../../views/brands/BrandExpenses.vue'
import BrandNotifications from '../../views/brands/BrandNotifications.vue'
import BrandNotification from '../../views/brands/BrandNotification.vue'
import CreateBrandNotification from '../../views/brands/CreateBrandNotification.vue'
import BrandSupplierScorecards from '../../views/brands/BrandSupplierScorecards.vue'
import CreateBrandSupplierScorecard from '../../views/brands/CreateBrandSupplierScorecard.vue'
import BrandSupplierScorecard from '../../views/brands/BrandSupplierScorecard.vue'
import CreateProjectBundle from '../../views/brands/CreateProjectBundle.vue'
import BrandProjectBundles from '../../views/brands/BrandProjectBundles.vue'
import BrandProjectBundle from '../../views/brands/BrandProjectBundle.vue'
import CreateBrandReportVisualGroup from '../../views/brands/CreateBrandReportVisualGroup.vue'
import BrandReportVisualGroup from '../../views/brands/BrandReportVisualGroup.vue'


import BrandInputSubmissionCharts from '../../views/brands/BrandInputSubmissionCharts.vue'


export const brands = {
      path: 'brands',
      name: 'Brands',
      component: Brands,
      beforeEnter : roleSystemRoute,
      meta: {
          title: "markalar",
          domain:"brands",
          accessroles:["admin","brand","auditor","planner"],
        },
      }
export const create_brand = {
      path: 'brand',  
      name: 'CreateBrand',
      component: CreateBrand,
      meta: {
          title: "Yeni Marka",
          preloader:true,
          domain:"brands",
          accessroles:["admin","brand","auditor","planner"],
        },
      }
export const brand = {
      path: 'brand/:id',  
      name: 'Brand',
      component: Brand,
      beforeEnter : roleSystemRoute,
      redirect: { name: 'BrandStatus' },
      meta: {
          title: "Marka",
          preloader:true,
          domain:"brands",
          accessroles:["admin","brand","planner"],
        },
        children:[
          {
          path: 'general',  
          name: 'BrandGeneral',
          component: BrandGeneral,
          meta: {
              title: "genel",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'translations',  
          name: 'BrandTranslations',
          component: BrandTranslations,
          meta: {
              title: "ceviriler",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'suppliers',  
          name: 'BrandSuppliers',
          component: BrandSuppliers,
          meta: {
              title: "tedarikciler",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'projects',  
          name: 'BrandProjects',
          component: BrandProjects,
          meta: {
              title: "projeler",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'project',  
          name: 'CreateBrandProject',
          component: CreateBrandProject,
          meta: {
              title: "yeni_marka_projesi",
              preloader:true,
              domain:"brands"
            },
          },          
          {
          path: 'status',  
          name: 'BrandStatus',
          component: BrandStatus,
          meta: {
              title: "durum",
              preloader:true,
              domain:"brands"
            },
          },  
          {
          path: 'input_submissions',  
          name: 'BrandInputSubmissionCharts',
          component: BrandInputSubmissionCharts,
          meta: {
              title: "marka_veri_girisleri",
              preloader:true,
              domain:"brands"
            },  
          },
          {
          path: 'business_return',  
          name: 'BrandExpenses',
          component: BrandExpenses,
          meta: {
              title: "is_bedelleri",
              preloader:true,
              domain:"brands"
            },  
          }, 
          {
          path: 'brand_notifications',  
          name: 'BrandNotifications',
          component: BrandNotifications,
          meta: {
              title: "marka_bildirimleri",
              preloader:true,
              domain:"brands"
            },  
          }, 
          {
          path: 'new_brand_notification',  
          name: 'CreateBrandNotification',
          component: CreateBrandNotification,
          meta: {
              title: "marka_bildirimi",
              preloader:true,
              domain:"brands"
            },  
          },  
          {
          path: 'brand_notification/:notification_id',  
          name: 'BrandNotification',
          component: BrandNotification,
          meta: {
              title: "marka_bildirimleri",
              preloader:true,
              domain:"brands"
            },  
          },            
          {
          path: 'supplier_cards',  
          name: 'BrandSupplierScorecards',
          component: BrandSupplierScorecards,
          meta: {
              title: "tedarikci_kartlari",
              preloader:true,
              domain:"brands"
            },  
          },
          {
          path: 'new_supplier_card',  
          name: 'CreateBrandSupplierScorecard',
          component: CreateBrandSupplierScorecard,
          meta: {
              title: "tedarikci_karti",
              preloader:true,
              domain:"brands"
            },  
          },  
          {
          path: 'supplier_card/:card_id',  
          name: 'BrandSupplierScorecard',
          component: BrandSupplierScorecard,
          meta: {
              title: "tedarikci_karti",
              preloader:true,
              domain:"brands"
            },  
          },
          {
          path: 'brand_reports',  
          name: 'BrandReports',
          component: BrandReports,
          meta: {
              title: "marka_raporlari",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'new_brand_report',  
          name: 'NewBrandReport',
          component: BrandReportEdit,
          meta: {
              title: "marka_raporu",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'brand_report_edit/:report_id',  
          name: 'BrandReportEdit',
          component: BrandReportEdit,
          meta: {
              title: "marka_raporu",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'brand_report/:report_id',  
          name: 'BrandReport',
          component: BrandReport,
          meta: {
              title: "marka_raporu",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'custom_attributes',  
          name: 'BrandCustomAttributes',
          component: BrandCustomAttributes,
          meta: {
              title: "marka_ozel_nitelikleri",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'project_bundles',  
          name: 'BrandProjectBundles',
          component: BrandProjectBundles,
          meta: {
              title: "proje_paketleri",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'create_custom_attribute',  
          name: 'CreateBrandCustomAttribute',
          component: CreateBrandCustomAttribute,
          meta: {
              title: "yeni_marka_ozel_niteligi",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'create_custom_attribute_group',  
          name: 'CreateBrandCustomAttributeGroup',
          component: CreateBrandCustomAttributeGroup,
          meta: {
              title: "yeni_marka_ozel_nitelik_grubu",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'brand_report_group/:group_id',  
          name: 'BrandReportVisualGroup',
          component: BrandReportVisualGroup,
          meta: {
              title: "rapor_grubu",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'create_project_bundle',  
          name: 'CreateProjectBundle',
          component: CreateProjectBundle,
          meta: {
              title: "yeni_proje_paketi",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'create_project_report_group',  
          name: 'CreateBrandReportVisualGroup',
          component: CreateBrandReportVisualGroup,
          meta: {
              title: "yeni_rapor_grubu",
              preloader:true,
              domain:"brands"
            },
          }, 
          {
          path: 'custom_attribute/:attribute_id',  
          name: 'BrandCustomAttribute',
          component: BrandCustomAttribute,
          meta: {
              title: "marka_ozel_niteligi",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'project_bundle/:bundle_id',  
          name: 'BrandProjectBundle',
          component: BrandProjectBundle,
          meta: {
              title: "proje_paketi",
              preloader:true,
              domain:"brands"
            },
          },                 
          {
          path: 'custom_attribute_group/:group_id',  
          name: 'BrandCustomAttributeGroup',
          component: BrandCustomAttributeGroup,
          meta: {
              title: "marka_ozel_nitelik_grubu",
              preloader:true,
              domain:"brands"
            },
          },                 
          {
          path: 'users',  
          name: 'BrandUsers',
          component: BrandUsers,
          meta: {
              title: "marka_kullanicilari",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'user',  
          name: 'CreateBrandUser',
          component: CreateBrandUser,
          meta: {
              title: "yeni_marka_kullanicisi",
              preloader:true,
              domain:"brands"
            },
          },
          {
          path: 'user/:user_id',  
          name: 'BrandUser',
          component: BrandUser,
          meta: {
              title: "marka_kullanicisi",
              preloader:true,
              domain:"brands"
            },
          },
        ]
      }